import script from "./HistoryData.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryData.vue?vue&type=script&setup=true&lang=js"

import "./HistoryData.vue?vue&type=style&index=0&id=02b78a6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b78a6a"]])

export default __exports__